import { cn } from '@mntn/ui-components'
import { Spin } from 'antd'

interface FlightDeckSpinnerProps {
  size?: 'small' | 'default' | 'large'
  tip?: string
  className?: string
  spinning?: boolean
  children?: React.ReactNode
}

const SpinnerStyles = () => (
  <style>{`
    .flight-deck-spinner .ant-spin-show-text {
      display: flex;
      flex-direction: column;
    }

    .flight-deck-spinner .ant-spin-text {
      font-size: 18px;
      line-height: 16px;
      color: #000000;
      margin-top: 12px;
    }

    .flight-deck-spinner .ant-spin-dot-item {
      background-color: #1AC9AA;
    }
  `}</style>
)

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
const FlightDeckSpinner: React.FC<FlightDeckSpinnerProps> = ({
  size = 'default',
  tip,
  className,
  spinning = true,
  children,
}) => {
  return (
    <>
      <SpinnerStyles />
      <div className={cn('flex items-center justify-center h-full w-full', className)}>
        <Spin size={size} tip={tip} spinning={spinning} className="flight-deck-spinner" fullscreen={true}>
          {children}
        </Spin>
      </div>
    </>
  )
}

// Styled loading element for session provider
export const FlightDeckLoadingElement = () => {
  return (
    <div className="h-full w-full">
      <FlightDeckSpinner size="large" tip="Loading..." spinning={true}>
        <div style={{ minHeight: '50px' }} />
      </FlightDeckSpinner>
    </div>
  )
}
